window.checkFavoriteStatus = function(url, type) {
    var $els = [];
    $('[data-favorite="'+ type +'"]:not(.favorite-checked)').each(function (k, v) {
        var $el = $(v);
        $el.addClass('favorite-checked');
        $els.push($el)
    })

    if ($els.length > 0) {
        $.post(url, {ids: $els.map(function ($el) { return $el.data('id'); })}, function(response) {
            $.each($els, function(k, $el) {
                if (response.indexOf($el.data('id')) > -1) {
                    $el.addClass('is-favorite')
                }
            })
        }, 'json')
    }
}

loadjs.ready(['jquery', 'core'], function() {
    $('body').on('click', '[data-favorite]', function (e) {
        var $el = $(this);
        e.preventDefault();
        if (_user) {
            $.post(routes.favorite.toggle[$el.data('favorite')].replace('_id_', $el.data('id')), function (response) {
                $el.toggleClass('is-favorite', response.status === 1)
                if ($el.data('favorite') === 'products' && response.status === 1 && usedPixels.length) {
                    var ev = getEventId();
                    var data = {content_ids: [$el.data('id')]};
                    fbq('track', 'AddToWishlist', data, {eventID: ev});
                    ttq.track('AddToWishlist', data);
                    conversionAPI(usedPixels, ev, 'AddToWishlist', data);
                }
            })
        } else {
            $('#connect-modal').modal('show');
        }

        return false;
    })
})
